import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
const STOP_REGION = process.env.REACT_APP_STOP_REGION

export const getVerificationDischarge6MasterReferenceData = createAsyncThunk(
  'stop/getVerificationDischarge6MasterReferenceData',
  async (params) => {
    const { url, payload, authorization } = params;
    const config = {
      headers: {
        Authorization: authorization,
        Region: STOP_REGION
      },
    };
    const response = await axios
      .post(url, payload, config)
      .then((response) => {
        return response;
      })
      .catch((e) => {
        console.log(e);
        return e;
      });
    const data = await response.data.data;
    return data === undefined ? null : data;
  }
);

const verificationDischarge6MasterReferenceSlice = createSlice({
  name: 'stop/verificationDischarge6MasterReferenceSlice',
  initialState: null,
  reducers: {
    resetVerificationDischarge6MasterReference: () => null,
  },
  extraReducers: {
    [getVerificationDischarge6MasterReferenceData.fulfilled]: (state, action) =>
      action.payload,
  },
});

export const { resetVerificationDischarge6MasterReference } =
  verificationDischarge6MasterReferenceSlice.actions;

export default verificationDischarge6MasterReferenceSlice.reducer;
